import React, { useState } from 'react';
import { Download, CheckCircle, AlertCircle, ChevronDown, ChevronUp, Calendar, Mail, Edit2, Send, User } from 'lucide-react';
export function WonkaApplicationView() {
  const [expandedRef, setExpandedRef] = useState<string | null>(null);
  const [expandedGuarantor, setExpandedGuarantor] = useState<string | null>(null);
  const tradeReferences = [{
    id: 'sweetco',
    company: 'SweetCo Distributors',
    status: 'pending',
    statusText: 'Pending since January 15, 2026',
    emailsSent: '1 email sent',
    contact: {
      name: 'Robert Sweet',
      phone: '(555) 555-0142',
      email: 'r.sweet@sweetcodist.com'
    },
    details: null
  }, {
    id: 'candymax',
    company: 'CandyMax Wholesale',
    status: 'completed',
    statusText: 'Completed on January 12, 2026',
    emailsSent: '1 email sent',
    contact: {
      name: 'Patricia Candy',
      phone: '(717) 555-0188',
      email: 'p.candy@candymax.com'
    },
    details: {
      yearsAsCustomer: 8,
      creditLimit: '$125,000',
      currentBalance: '$12,500',
      paymentHabits: 'Prompt / Within Terms',
      recommended: 'Yes',
      responseDate: 'January 12, 2026'
    }
  }, {
    id: 'sugarworks',
    company: 'SugarWorks Supply Co.',
    status: 'not-sent',
    statusText: 'Not Sent',
    emailsSent: null,
    contact: {
      name: 'James Sugar',
      phone: '(703) 555-0177',
      email: 'j.sugar@sugarworks.com',
      address: '6885 Elm Street, McLean VA 22101'
    },
    details: null
  }];
  return <div className="space-y-6" data-id="element-3091" data-mp="1qpjy9fjfxsyu">
      {/* Application Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3092" data-mp="1lppa3jr1vhhh">
        <div className="flex items-center justify-between mb-4" data-id="element-3093" data-mp="1zndwiw0rmwon">
          <div data-id="element-3094" data-mp="1vmk7fzbl7bu6">
            <div className="flex items-center gap-3 mb-2" data-id="element-3095" data-mp="1vn3prh55g28q">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-3096" data-mp="1vkh6wlct60b7">
                Credit Application
              </h2>
              <span className="px-3 py-1 bg-green-100 text-green-700 border border-green-300 rounded-full text-sm font-medium flex items-center gap-1" data-id="element-3097" data-mp="27ouxhaa0vhqr">
                <span className="text-lg" data-id="element-3098" data-mp="2cn68vpfyu0b3">🔍</span>
                Ready for Review
              </span>
            </div>
            <div className="text-sm text-gray-600 space-y-1" data-id="element-3099" data-mp="2hfzcub3m14m4">
              <p data-id="element-3100" data-mp="2lf851bj04ufk">
                <span className="font-semibold" data-id="element-3101" data-mp="2lfqa8xnn6izm">Started On:</span> January 10,
                2026
              </p>
              <p data-id="element-3102" data-mp="2qdi3pw3xqd5x">
                <span className="font-semibold" data-id="element-3103" data-mp="2qh5x8v9dqzkn">Submitted On:</span> January 10,
                2026
              </p>
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-3104" data-mp="30ch995telsop">
            <Download className="w-4 h-4" data-id="element-3105" data-mp="15zhqj3tq8id7" />
            DOWNLOAD PDF
          </button>
        </div>
      </div>

      {/* Applicant Details */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3106" data-mp="3jasvfajqr69q">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3107" data-mp="3eij2dlnbxq38">
          Applicant Details
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3108" data-mp="3ago0aexkr8oe">
          <div data-id="element-3109" data-mp="3af330hjvlbmu">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3110" data-mp="35imgfrsbr5bv">
              Name
            </label>
            <p className="text-gray-900" data-id="element-3111" data-mp="63r35t0lxxcc">Charlie Bucket</p>
          </div>
          <div data-id="element-3112" data-mp="21nrp4dxusr2">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3113" data-mp="214axr00yaem">
              Company
            </label>
            <p className="text-gray-900" data-id="element-3114" data-mp="3t6vyqjqbxay9">Wonka Industries</p>
          </div>
          <div data-id="element-3115" data-mp="3o943pgue18pu">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3116" data-mp="3o9nco8228mrq">
              Role
            </label>
            <p className="text-gray-900" data-id="element-3117" data-mp="2htl25nwt8zyo">Factory Manager</p>
          </div>
          <div data-id="element-3118" data-mp="2ctfjuycfkpt9">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3119" data-mp="2csnq7t2e925m">
              Department
            </label>
            <p className="text-gray-900" data-id="element-3120" data-mp="4jpkt29iv3ri">Operations</p>
          </div>
          <div data-id="element-3121" data-mp="9cr2tj50zjfb">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3122" data-mp="9daa85x1upf3">
              Email
            </label>
            <div className="flex items-center gap-2" data-id="element-3123" data-mp="3rrjgajarf23j">
              <p className="text-gray-900" data-id="element-3124" data-mp="im7amey5jtg">charlie.bucket@wonka.com</p>
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-3125" data-mp="o8zy69lspcmg" />
            </div>
          </div>
          <div data-id="element-3126" data-mp="sal7jkz4f8rw">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3127" data-mp="sb3dj9bl51d0">
              Phone Number
            </label>
            {/* Modified: Changed label from 'Phone Number' to 'Phone'  */}
            <p className="text-gray-900" data-id="element-3128" data-mp="j9dmi4lm84fr">(555) 555-0200</p>
          </div>
        </div>

        {/* Email Verification */}
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-3129" data-mp="2yzzs0kzb2xuo">
          <div className="flex items-start gap-3" data-id="element-3130" data-mp="340e4cf7xwtyi">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-3131" data-mp="33y1bh70n8z6o" />
            <div data-id="element-3132" data-mp="2wfa7p10owr27">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-3133" data-mp="2wes41jbp7ak9">
                Email Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-3134" data-mp="2rjuv0cef517d">
                Email verified and matches company domain.
              </p>
            </div>
          </div>
        </div>

        {/* IP Address */}
        <div className="mt-4" data-id="element-3135" data-mp="30gdpht2asx62">
          <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3136" data-mp="2cruf97zouabc">
            Location (IP Address)
          </label>
          <div className="flex items-center gap-2" data-id="element-3137" data-mp="28sbxum72shd9">
            <p className="text-gray-900" data-id="element-3138" data-mp="2mi5jywr74nja">London, UK (185.45.23.112)</p>
            <CheckCircle className="w-4 h-4 text-green-600" data-id="element-3139" data-mp="2mkicg3ukygal" />
          </div>
        </div>

        {/* IP Verification */}
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-3140" data-mp="1u24iwgga1ghb">
          <div className="flex items-start gap-3" data-id="element-3141" data-mp="1tzrtji86w3u8">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-3142" data-mp="1p205izao11vb" />
            <div data-id="element-3143" data-mp="3p5kfscru7u0m">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-3144" data-mp="3p62kzywh9iko">
                IP Address Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-3145" data-mp="3u2t1gnc72g6m">
                Applicant location matches company headquarters.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Company Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3146" data-mp="7qvxqz5epwml">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3147" data-mp="3689iuytohcoc">
          Company Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3148" data-mp="3b5ruiwz2y601">
          <div data-id="element-3149" data-mp="3g4cssquruflu">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3150" data-mp="3g3tf5mc5mddm">
              Legal Business Name
            </label>
            <p className="text-gray-900" data-id="element-3151" data-mp="3k43kqxw1b1ry">Wonka Industries Inc.</p>
          </div>
          <div data-id="element-3152" data-mp="ve3z55zpsljc">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3153" data-mp="vggi9mh7l1xz">
              DBA
            </label>
            <p className="text-gray-900" data-id="element-3154" data-mp="2jy00mzgiji2m">Wonka Chocolate Factory</p>
          </div>
          <div data-id="element-3155" data-mp="2k046vo1vwt62">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3156" data-mp="2fwefyrxqlzhv">
              Business Address
            </label>
            <p className="text-gray-900" data-id="element-3157" data-mp="2b4wfs63jg2xy">
              1 Chocolate Avenue
              <br data-id="element-3158" data-mp="266ux3ma0y5n0" />
              Hershey, PA 17033
            </p>
          </div>
          <div data-id="element-3159" data-mp="264s895klyijv">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3160" data-mp="217a0hiibu9dg">
              Years in Business
            </label>
            <p className="text-gray-900" data-id="element-3161" data-mp="1w7dsl86idxsm">52 years</p>
          </div>
          <div data-id="element-3162" data-mp="1s6k5ui4syp1b">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3163" data-mp="1s621ey7zl4ib">
              Tax ID / EIN
            </label>
            <p className="text-gray-900" data-id="element-3164" data-mp="1n924pdx11e3v">**-***7845</p>
          </div>
          <div data-id="element-3165" data-mp="3mlede9ivgbm6">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3166" data-mp="3mjtkspg4b2qy">
              Industry
            </label>
            <p className="text-gray-900" data-id="element-3167" data-mp="3hmb76lr5nzcm">Confectionery & Candy Manufacturing</p>
          </div>
        </div>
      </div>

      {/* Requested Credit Terms */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3168" data-mp="2vg0knif0ashf">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3169" data-mp="2gqmbaabfkb21">
          Requested Credit Terms
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3170" data-mp="2lpfriai3qg5w">
          <div data-id="element-3171" data-mp="2lnuso8or8b28">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3172" data-mp="2lncrcxn8j6ng">
              Requested Credit Limit
            </label>
            <p className="text-gray-900 text-lg font-semibold" data-id="element-3173" data-mp="2brrvlh8rf2m5">$100,000</p>
          </div>
          <div data-id="element-3174" data-mp="1xsa0kk4vet4c">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3175" data-mp="1xss6k8hc4lpg">
              Payment Terms
            </label>
            <p className="text-gray-900" data-id="element-3176" data-mp="22rd5m4kuozcb">Net 30</p>
          </div>
          <div data-id="element-3177" data-mp="3s5hzonzvpqvs">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3178" data-mp="3s72vegxxjfv8">
              Estimated Monthly Volume
            </label>
            <p className="text-gray-900" data-id="element-3179" data-mp="xdupkbn4k05">$25,000 - $35,000</p>
          </div>
          <div data-id="element-3180" data-mp="1li0t3ibie6b7">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3181" data-mp="1lfeq7vzkcezb">
              Purpose
            </label>
            <p className="text-gray-900" data-id="element-3182" data-mp="1v7c2z767zf05">Raw materials and ingredients</p>
          </div>
        </div>
      </div>

      {/* Trade References */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3183" data-mp="1qfu02dkmz4cj">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3184" data-mp="2477j7qemu071">
          Trade References
        </h3>
        <div className="space-y-3" data-id="element-3185" data-mp="1z9p5lmpo6wsp">
          {tradeReferences.map(ref => <div key={ref.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-3186" data-mp="2e5wsiusgqcbo">
              {/* Collapsed Header */}
              <button onClick={() => setExpandedRef(expandedRef === ref.id ? null : ref.id)} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3187" data-mp="29590q6wetrge">
                <div className="flex items-center gap-4" data-id="element-3188" data-mp="3uyr1imhsr5zu">
                  <span className="font-semibold text-gray-900" data-id="element-3189" data-mp="3pxju4ojkg8tp">
                    {ref.company}
                  </span>
                  <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-3190" data-mp="3l01kevxq5pkn">
                    <div className="flex items-center gap-1" data-id="element-3191" data-mp="3g0owe7v4acgh">
                      <Calendar className="w-4 h-4" data-id="element-3192" data-mp="3g29rbylcfxev" />
                      {ref.statusText}
                    </div>
                    {ref.emailsSent && <>
                        <span className="text-gray-300" data-id="element-3193" data-mp="cl9nj9yh68wx">•</span>
                        <div className="flex items-center gap-1" data-id="element-3194" data-mp="7r5gkqp7m0vu">
                          <Mail className="w-4 h-4" data-id="element-3195" data-mp="2tn811f3tnod" />
                          {ref.emailsSent}
                        </div>
                      </>}
                  </div>
                </div>
                {expandedRef === ref.id ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-3196" data-mp="vfy3xyrrn0eu" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-3197" data-mp="13s9ne133f766" />}
              </button>

              {/* Expanded Content */}
              {expandedRef === ref.id && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-3198" data-mp="1cps977ok9pj4">
                  {/* Reference Information */}
                  <div className="mb-6" data-id="element-3199" data-mp="1hodc5ev76nb9">
                    <div className="flex items-center gap-2 mb-4" data-id="element-3200" data-mp="1mq2p501zdb1z">
                      <span className="font-semibold text-gray-900" data-id="element-3201" data-mp="1mnq6ekoeewnv">
                        Reference Information
                      </span>
                      <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-3202" data-mp="1viw6d30zmkih" />
                    </div>
                    <div className="grid grid-cols-2 gap-6" data-id="element-3203" data-mp="20fwf5lp821da">
                      <div data-id="element-3204" data-mp="25galmzb6d397">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-3205" data-mp="25h3ldgbpushu">
                          Company Name
                        </label>
                        <p className="text-gray-900" data-id="element-3206" data-mp="2acra5umadjmt">{ref.company}</p>
                      </div>
                      <div data-id="element-3207" data-mp="1koviae1pzybk">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-3208" data-mp="1fs53du1nj8rq">
                          Contact Name
                        </label>
                        <p className="text-gray-900" data-id="element-3209" data-mp="1uiciq0wd4bo7">{ref.contact.name}</p>
                      </div>
                      <div data-id="element-3210" data-mp="1porq6odjg9we">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-3211" data-mp="23hhcyv0w5iuk">
                          Contact Phone Number
                        </label>
                        <p className="text-gray-900" data-id="element-3212" data-mp="1yhlbp3jkw5ip">{ref.contact.phone}</p>
                      </div>
                      <div data-id="element-3213" data-mp="2df59nqi250fd">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-3214" data-mp="2ddazn78bqsq2">
                          Contact Work Email
                        </label>
                        <p className="text-gray-900" data-id="element-3215" data-mp="j2nr2w85yoh2">{ref.contact.email}</p>
                      </div>
                      {ref.contact.address && <div className="col-span-2" data-id="element-3216" data-mp="2ppwke8wi11px">
                          <label className="text-sm text-gray-500 mb-1 block" data-id="element-3217" data-mp="2pr7mm4aaq1ex">
                            Company Address
                          </label>
                          <p className="text-gray-900" data-id="element-3218" data-mp="2g0cysvheitrd">{ref.contact.address}</p>
                        </div>}
                    </div>
                  </div>

                  {/* Status-specific content */}
                  {ref.status === 'pending' && <div data-id="element-3219" data-mp="271rkjciyq0we">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-3220" data-mp="2b1i8l8h3u2x8">
                        Awaiting Response
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-3221" data-mp="1x2sdtzhrcfc1">
                        The reference request has been sent 1 times.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-3222" data-mp="3reyxznsmq6gh">
                        <Send className="w-4 h-4" data-id="element-3223" data-mp="1wc3ku7q6xwqe" />
                        SEND REMINDER
                      </button>
                    </div>}

                  {ref.status === 'completed' && ref.details && <div data-id="element-3224" data-mp="1nam72w09a74v">
                      <div className="flex items-center gap-2 mb-4" data-id="element-3225" data-mp="1n9udfqq7yjh8">
                        <div className="font-semibold text-gray-900" data-id="element-3226" data-mp="1id419ehjc813">
                          Reference Completed
                        </div>
                        <CheckCircle className="w-5 h-5 text-green-600" data-id="element-3227" data-mp="1dfauokcblc0a" />
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-3228" data-mp="18kepsjlziu5r">
                        Response received on {ref.details.responseDate}
                      </p>
                      <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-3229" data-mp="zn4cyttiqwyq">
                        <div className="flex justify-between" data-id="element-3230" data-mp="umzwv4wiw491">
                          <span className="text-gray-600" data-id="element-3231" data-mp="pnn98hxtut5e">
                            Years as Customer
                          </span>
                          <span className="font-medium text-gray-900" data-id="element-3232" data-mp="31bs6g86iksjo">
                            {ref.details.yearsAsCustomer}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-3233" data-mp="3b8ws86wg6lzy">
                          <span className="text-gray-600" data-id="element-3234" data-mp="3b7c00nxlvf59">Credit Limit</span>
                          <span className="font-medium text-gray-900" data-id="element-3235" data-mp="3f9ysmr23p43i">
                            {ref.details.creditLimit}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-3236" data-mp="2nk3rzy8slrzj">
                          <span className="text-gray-600" data-id="element-3237" data-mp="2rknor0pgetl5">Current Balance</span>
                          <span className="font-medium text-gray-900" data-id="element-3238" data-mp="2wbw227twmz3l">
                            {ref.details.currentBalance}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-3239" data-mp="1zs6pwyv5aebm">
                          <span className="text-gray-600" data-id="element-3240" data-mp="23u1uqdcab9u5">Payment Habits</span>
                          <span className="font-medium text-gray-900" data-id="element-3241" data-mp="375gzx2hafdun">
                            {ref.details.paymentHabits}
                          </span>
                        </div>
                        <div className="flex justify-between col-span-2" data-id="element-3242" data-mp="3gwlei131wwoy">
                          <span className="text-gray-600" data-id="element-3243" data-mp="3bxh4x9c7swy3">Recommended</span>
                          <span className="font-medium text-gray-900" data-id="element-3244" data-mp="3bzbpgmjkqn1n">
                            {ref.details.recommended}
                          </span>
                        </div>
                      </div>
                    </div>}

                  {ref.status === 'not-sent' && <div data-id="element-3245" data-mp="2x5zxqv18vi3f">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-3246" data-mp="2t67u8wqpk24x">
                        Ready to Send
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-3247" data-mp="cgium6kxgvkc">
                        This trade reference request has not yet been sent to
                        the contact.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-3248" data-mp="fyq3zgrp0e6d">
                        <Send className="w-4 h-4" data-id="element-3249" data-mp="62wqnv65ggnj" />
                        SEND REFERENCE
                      </button>
                    </div>}
                </div>}
            </div>)}
        </div>

        {/* Additional Trade References */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-3250" data-mp="13pvkly5gjahq">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-3251" data-mp="13rgc1ewh6dbd">
            Additional Trade References
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-3252" data-mp="tzj1madajpdp">
            No additional references requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-3253" data-mp="1hp4xooyd9ohh">
            <Send className="w-4 h-4" data-id="element-3254" data-mp="1mhy3lg5kn2v5" />
            REQUEST ADDITIONAL TRADE REFERENCES
          </button>
        </div>
      </div>

      {/* Personal Guarantors */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3255" data-mp="3drq7kozqnie0">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3256" data-mp="39rzjwu5ididp">
          Personal Guarantors
        </h3>
        <div className="space-y-3" data-id="element-3257" data-mp="34swfnbxcrg6s">
          {/* Willy Wonka - Completed */}
          <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-3258" data-mp="5d80oqlja8vz">
            {/* Collapsed Header */}
            <button onClick={() => setExpandedGuarantor(expandedGuarantor === 'willy' ? null : 'willy')} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3259" data-mp="1c646hj04axp">
              <div className="flex items-center gap-4" data-id="element-3260" data-mp="2h31zakdtr9hs">
                <span className="font-semibold text-gray-900" data-id="element-3261" data-mp="2c3foehlgy5c5">Willy Wonka</span>
                <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-3262" data-mp="2c5io5tcfbcu2">
                  <div className="flex items-center gap-1" data-id="element-3263" data-mp="221274wn7jpoo">
                    <Calendar className="w-4 h-4" data-id="element-3264" data-mp="26xiz61xj2o71" />
                    {/* Changed from 'Completed on January 10, 2026' to just 'Completed on January 10, 2026' as in initial code's pattern */}
                    Completed on January 10, 2026
                  </div>
                  <span className="text-gray-300" data-id="element-3265" data-mp="2kpqpbaub3gwr">•</span>
                  <div className="flex items-center gap-1" data-id="element-3266" data-mp="2kp75tpp0ckgm">
                    <Mail className="w-4 h-4" data-id="element-3267" data-mp="2poabncctaupn" />1 email sent
                  </div>
                </div>
              </div>
              {expandedGuarantor === 'willy' ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-3268" data-mp="2zmzkygqn76ua" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-3269" data-mp="2zkwvpyxbdhqm" />}
            </button>

            {/* Expanded Content */}
            {expandedGuarantor === 'willy' && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-3270" data-mp="1598dnnvscz20">
                {/* Guarantor Information */}
                <div className="mb-6" data-id="element-3271" data-mp="39b7667fmuhx1">
                  <div className="flex items-center gap-2 mb-4" data-id="element-3272" data-mp="3ddu32mr5ut13">
                    <User className="w-4 h-4 text-gray-600" data-id="element-3273" data-mp="3idor8ijjx4ig" />
                    <span className="font-semibold text-gray-900" data-id="element-3274" data-mp="3ic5cwxhgh3jb">
                      Guarantor Information
                    </span>
                    <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-3275" data-mp="3s3i1ng7yjdl4" />
                  </div>
                  <div className="grid grid-cols-2 gap-6" data-id="element-3276" data-mp="x6zfgr7o6s7">
                    <div data-id="element-3277" data-mp="vnhzmttjpou">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3278" data-mp="z1jytyklwvr">
                        Full Name
                      </label>
                      <p className="text-gray-900" data-id="element-3279" data-mp="9y53u05kagbb">Willy Wonka</p>
                    </div>
                    <div data-id="element-3280" data-mp="26qougukf4t65">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3281" data-mp="26rgkzqz5s0pk">
                        Title
                      </label>
                      <p className="text-gray-900" data-id="element-3282" data-mp="2br30k72glt1j">Owner & Chief Chocolatier</p>
                    </div>
                    <div data-id="element-3283" data-mp="247jwwe1vl10z">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3284" data-mp="1zeigu2pxmvft">
                        Email
                      </label>
                      <p className="text-gray-900" data-id="element-3285" data-mp="1uggxrhsiaw4c">willy.wonka@wonka.com</p>
                    </div>
                    <div data-id="element-3286" data-mp="1pifil7y7bgy5">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3287" data-mp="1pezy1plrdfpc">
                        Phone
                      </label>
                      {/* Modified: Changed label from 'Phone' to 'Phone' (already same), but keeping consistency */}
                      <p className="text-gray-900" data-id="element-3288" data-mp="2d5dvxwr0y8ru">(555) 555-0100</p>
                    </div>
                    <div data-id="element-3289" data-mp="293sa3lwiik5i">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3290" data-mp="294k62xu0ujwb">
                        Address
                      </label>
                      {/* Modified: Changed 'Address' label to 'Address' (already same), with new content below */}
                      <p className="text-gray-900" data-id="element-3291" data-mp="z6apbcdazulg">
                        1 Chocolate Lane, London, UK W1A 1AA
                      </p>
                    </div>
                    <div data-id="element-3292" data-mp="143u9su0lh3lu">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3293" data-mp="p8wh201jac48">
                        SSN
                      </label>
                      {/* Modified: Changed label from 'SSN' to 'SSN' (already same), with same content */}
                      <p className="text-gray-900" data-id="element-3294" data-mp="gfkmtorna9t4">***-**-1971</p>
                    </div>
                  </div>
                </div>

                {/* Guarantee Completed */}
                <div data-id="element-3295" data-mp="6j7rynkd5pws">
                  <div className="flex items-center gap-2 mb-4" data-id="element-3296" data-mp="6jpyqe4njmiy">
                    <div className="font-semibold text-gray-900" data-id="element-3297" data-mp="bggcguszi617">
                      Guarantee Completed
                    </div>
                    <CheckCircle className="w-5 h-5 text-green-600" data-id="element-3298" data-mp="3tne6s6198wbi" />
                  </div>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-3299" data-mp="1ik2w7fp3j57">
                    Personal guarantee signed on January 10, 2026
                  </p>
                  <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-3300" data-mp="3a1cbuv22g3qx">
                    <div className="flex justify-between" data-id="element-3301" data-mp="3a3fc07wxnd9d">
                      <span className="text-gray-600" data-id="element-3302" data-mp="3o1n4a2j0xqe7">Guarantee Amount</span>
                      <span className="font-medium text-gray-900" data-id="element-3303" data-mp="3j193n5jr5iq7">
                        $100,000
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-3304" data-mp="1rj3pjnn58xf">
                      <span className="text-gray-600" data-id="element-3305" data-mp="3syvpyd3dsck7">Date Signed</span>
                      <span className="font-medium text-gray-900" data-id="element-3306" data-mp="alpdwgiaiifw">
                        January 10, 2026
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-3307" data-mp="6mgofnua96q5">
                      <span className="text-gray-600" data-id="element-3308" data-mp="kl6lx4l0l8f1">Guarantee Type</span>
                      <span className="font-medium text-gray-900" data-id="element-3309" data-mp="flad8s1dgst5">
                        Unlimited
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-3310" data-mp="zmwmx1euof0v">
                      <span className="text-gray-600" data-id="element-3311" data-mp="13nylrh4uup2b">Expiration</span>
                      <span className="font-medium text-gray-900" data-id="element-3312" data-mp="18fgmc42yunmr">None</span>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>

        {/* Additional Personal Guarantors */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-3313" data-mp="gpvdn4e9jsr4">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-3314" data-mp="kpcko29c8xye">
            Additional Personal Guarantors
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-3315" data-mp="pnxlo3wezlnw">
            No additional guarantors requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-3316" data-mp="uov2od5ou9nt">
            <Send className="w-4 h-4" data-id="element-3317" data-mp="262pgenh1950d" />
            REQUEST ADDITIONAL PERSONAL GUARANTORS
          </button>
        </div>
      </div>

      {/* Banking Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3318" data-mp="3qncgqr0gp1e2">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3319" data-mp="3lmyfpsxa2rpj">
          Banking Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3320" data-mp="3gtn3fc9p5iq8">
          <div data-id="element-3321" data-mp="3bvbwpaep7oc8">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3322" data-mp="3bvll4tk3hnft">
              Bank Name
            </label>
            <p className="text-gray-900" data-id="element-3323" data-mp="37sp06w731f8p">PNC Bank</p>
          </div>
          <div data-id="element-3324" data-mp="32unlengow231">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3325" data-mp="32u41j17hb3md">
              Contact
            </label>
            <p className="text-gray-900" data-id="element-3326" data-mp="2xyop8dp4dfs2">Margaret Thompson</p>
          </div>
          <div data-id="element-3327" data-mp="2sz2c049ajzj9">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3328" data-mp="2szlubm2uspxt">
              Type of Account
            </label>
            <p className="text-gray-900" data-id="element-3329" data-mp="r6e2xe9yuhvk">Business Checking</p>
          </div>
          <div data-id="element-3330" data-mp="r41rljypr5rh">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3331" data-mp="2lmcuv0pwjfyf">
              Account #
            </label>
            <p className="text-gray-900" data-id="element-3332" data-mp="2qdkzzkk78f5s">987654321</p>
          </div>
          <div data-id="element-3333" data-mp="2qew45lhk3oxf">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3334" data-mp="2bogkwc8par1w">
              Email
            </label>
            <p className="text-gray-900" data-id="element-3335" data-mp="2gmi4qzdyauef">m.thompson@pnc.com</p>
          </div>
          <div data-id="element-3336" data-mp="34d40br6rqm7j">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3337" data-mp="34ckrczz3j85n">
              City
            </label>
            <p className="text-gray-900" data-id="element-3338" data-mp="39avyh2y0b4k6">Hershey</p>
          </div>
          <div data-id="element-3339" data-mp="2vcftphjpfo4o">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3340" data-mp="2vcxn86ezfo8w">
              State
            </label>
            <p className="text-gray-900" data-id="element-3341" data-mp="2zcg9b5iji5db">PA</p>
          </div>
          <div data-id="element-3342" data-mp="1jx911h9jyt95">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3343" data-mp="1jwr7ise9yt4x">
              Phone #
            </label>
            <p className="text-gray-900" data-id="element-3344" data-mp="1nzdrk74pf9rk">717-555-0300</p>
          </div>
          <div data-id="element-3345" data-mp="1gejy5i7ifaiw">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3346" data-mp="1ge1wu75zq644">
              Fax #
            </label>
            <p className="text-gray-900" data-id="element-3347" data-mp="1bfgtvzzct8bz">717-555-0301</p>
          </div>
        </div>
      </div>

      {/* Signature */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3348" data-mp="1qb6im5vxbzke">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3349" data-mp="1lepnusu7ymyc">Signature</h3>

        {/* Terms & Conditions */}
        <div className="mb-6" data-id="element-3350" data-mp="xmhfy2f7zm6j">
          <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-3351" data-mp="spqzvf3f0ql4">
            Terms & Conditions
          </h4>
          <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg mb-4" data-id="element-3352" data-mp="17ewzh4660itj">
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-3353" data-mp="12nokztpza79i">
              I understand that should my account become delinquent (terms of
              sale are based upon date of invoice) and that if the creditor
              elects to employ a third party to collect monies due, my company
              will be responsible for not only the original amount billed, but
              also all costs associated with the collection efforts including
              but not limited to reasonable attorney fees. Cash in Advance
              restrictions may be placed on any past due account. Customer will
              notify the creditor, in writing, of any ownership changes or legal
              means of doing business by the company under which credit was
              established.
            </p>
          </div>
          <p className="text-sm font-semibold text-gray-900 mb-6" data-id="element-3354" data-mp="ccvcfxbd2xab">
            By signing the below you give Wonka Industries Ltd., permission to
            check your bank and trade references.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3355" data-mp="m2x2gun9yprv">
          <div data-id="element-3356" data-mp="q5jy76n2guuc">
            <label className="text-sm font-medium text-gray-500 mb-2 block" data-id="element-3357" data-mp="q635ltf3c0u4">
              Signature
            </label>
            <div className="border-2 border-gray-300 rounded-lg p-4 bg-white h-32 flex items-center justify-center" data-id="element-3358" data-mp="v4o67ty98mj3">
              <svg viewBox="0 0 200 60" className="w-full h-full" style={{
              maxWidth: '200px'
            }} data-id="element-3359" data-mp="2fk2qnw02vjva">
                <path d="M 15 35 Q 25 15, 45 30 Q 65 45, 85 25 Q 105 10, 125 35 Q 145 50, 165 30 Q 175 20, 185 35" stroke="#1f2937" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-3360" data-mp="26lr0tw71cq3w" />
              </svg>
            </div>
          </div>
          <div data-id="element-3361" data-mp="2pjtmq24ae6xh">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3362" data-mp="2pjjyaiyw47tw">
              Printed Name
            </label>
            <p className="text-gray-900" data-id="element-3363" data-mp="2kkqs7blxnj3r">Willy Wonka</p>
          </div>
          <div data-id="element-3364" data-mp="3i0w71a6dl6s9">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3365" data-mp="3i1fsh0v8idb1">
              Title
            </label>
            <p className="text-gray-900" data-id="element-3366" data-mp="3d8mm68k4awwu">Owner & Chief Chocolatier</p>
          </div>
          <div data-id="element-3367" data-mp="354hj2x6r2a0v">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3368" data-mp="353zo03vtq1uj">
              Date
            </label>
            <p className="text-gray-900" data-id="element-3369" data-mp="314h3vabttusr">2026-01-10</p>
          </div>
        </div>
      </div>
    </div>;
}